<template>
<el-drawer
  :title="editRow && editRow.id ? '修改成员' : '新增成员'"
  :visible.sync="show">
  <div class="drawer-box" v-loading="loading">
    <el-form label-position="top" :model="model" :rules="rules" ref="modelForm">
      <!-- <div class="form-title">基本信息</div>  -->
      <!-- 账号（修改成员时隐藏） -->
      <el-form-item label="账号" prop="mobile" v-if="!isEdit" :rules="[{
        required: true,
        message: '请输入账号',
        trigger: 'blur' }]">
        <el-input maxlength="30"
          :disabled="!!editRow"
          show-word-limit placeholder="建议输入手机号" v-model="model.mobile" />
      </el-form-item>

      <!-- <el-form-item label="渠道" prop="cpaChannel" :rules="[{
        required: true,
        message: '请输入渠道',
        trigger: 'blur' }]">
        <el-input show-word-limit placeholder="请输入渠道" v-model="model.cpaChannel" />
      </el-form-item> -->

      <el-form-item label="昵称" prop="nickName" :rules="[{
        required: true,
        message: '请输入昵称',
        trigger: 'blur' }]">
        <el-input placeholder="请输入昵称" :disabled="editType === 1" v-model="model.nickName" />
      </el-form-item>

      <el-form-item label="密码" prop="zsPwd" v-if="editType !== 1" :rules="isEdit ? [] : [{
        required: true,
        message: '请输入密码',
        trigger: 'blur' }]">
        <el-input type="password" placeholder="请输入密码" v-model="model.zsPwd" />
      </el-form-item>  
      <!-- 渠道标签 -->
      <el-form-item label="渠道标签" prop="qdTagLabels" v-if="roleType === 1">
        <el-select
          v-model="model.qdTagLabels"
          multiple
          filterable
          placeholder="请选择渠道标签"
          style="width: 100%;">
          <el-option
            v-for="item in qdTagList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="高佣商品佣金比例(%)" v-if="editType !== 1" prop="bd" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <el-input placeholder="请输入" @input="validateNumberInput('bd', $event)" v-model="model.bd" />
      </el-form-item>
      <el-form-item label="DouyinHp报单商品佣金比例(%)" v-if="editType !== 1" prop="bdHp" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <el-input placeholder="请输入" @input="validateNumberInput('bdHp', $event)" v-model="model.bdHp" />
      </el-form-item>
      <!--  -->
      <el-form-item prop="bdChannelDeduction" v-if="editType !== 1" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <template slot="label">
          <span>高佣商品一级渠道固定扣点(%)
            <el-tooltip class="item" effect="dark" placement="top">
              <template slot="content">
                <span>设置后，该二级渠道在选品库看到的佣金比例会自动<br/>比一级渠道少几个点，并且报单后会按此结算</span>
              </template>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </template>
        <el-input placeholder="请输入" @input="validateNumberInput('bdChannelDeduction', $event, true)" v-model="model.bdChannelDeduction" />
      </el-form-item>
     
      <!-- <el-form-item label="专属商品佣金比例(%)" prop="bdZs" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <el-input placeholder="请输入" @input="validateNumberInput('bdZs', $event)" v-model="model.bdZs" />
      </el-form-item> -->
      <!-- * 专属商品一级渠道固定扣点(%)  -->
      <!-- <el-form-item label="专属商品一级渠道固定扣点(%)" prop="bdZsChannelDeduction" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <el-input placeholder="请输入" @input="validateNumberInput('bdZsChannelDeduction', $event, true)" v-model="model.bdZsChannelDeduction" />
      </el-form-item> -->
     
      <!-- <el-form-item label="抖音高佣佣金比例(%)" prop="douyinM2s" :rules="[{
        required: true,
        message: '请输入',
        trigger: 'blur' }]">
        <el-input placeholder="请输入" v-model="model.douyinM2s" />
      </el-form-item> -->
    </el-form>
  </div>
  <div class="drawer-footer">
    <el-button @click="$emit('close')">取消</el-button>
    <el-button @click="submitHandler" type="primary">确认</el-button>
  </div>
</el-drawer>
</template>

<script> 
import NP from 'number-precision'
import { saveAccount, editAccount} from '@/service/apis/group'
import { getChannelTagList } from '@/service/apis/supShopTag'
export default { 
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editRow: {
      type: Object,
      default: null
    },
    roleType: {
      type: Number,
      default: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    // 1 一级 2 二级
    editType () {
      if (this.editRow && this.editRow.editType) {
        return this.editRow.editType
      }
      return null
    },
    // 修改成员时账号、密码不必填
    isEdit () {
      return !!(this.editRow && this.editRow.id)
    }
  },
  watch: {
    value: {
      handler: function(val) {
        if (val && this.editRow) {
          this.initForm()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      loading: false,
      rules: {},
      qdTagList: [],
      model: {
        mobile: '', 
        // cpaChannel: '',
        nickName: '',
        zsPwd: '',
        bd: '',
        bdHp: '',
        bdZs: '',
        bdChannelDeduction: '',
        bdZsChannelDeduction: '',
        // pdd: '',
        // douyinM2s: ''
        qdTagLabels: []
      }
    }
  },
  created () { 
    this.getChannelTagList()
  },
  methods: {
    async getChannelTagList () {
      const res = await getChannelTagList.call(this)
      this.qdTagList = [...(res || [])].map(item => ({
        label: item.tagLabel,
        value: item.tagCode,
      }))
    },
    validateNumberInput(field, value, isInteger = false) {
      // 使用正则表达式只允许输入数字和小数点
      let numericValue = value.replace(/[^\d.-]/g, '') // 只保留数字和小数点
        .replace(/^(\d+\.?\d*)(.*)$/, '$1') // 只保留第一个小数点
        .replace(/(?!^)-/g, '') // 只保留第一个负号，且必须在开头
        // .replace(/^(\d+\.?\d{0,2}).*$/, '$1') // 限制小数点后最多两位
      
      if (isInteger) {
        numericValue = numericValue.replace(/[.]/g, '') // 去掉小数点
      }
      
      this.model[field] = numericValue
    },
    // 提交
    submitHandler () {
      this.$refs['modelForm'].validate((valid) => {
        if (valid) {
          let opt = JSON.parse(JSON.stringify(this.model))
          // opt.userPromotion = {
          //   pdd: NP.times(opt.pdd, 1000),
          //   douyinM2s: NP.times(opt.douyinM2s, 1000),
          // }
          // delete opt.pdd
          // delete opt.douyinM2s

          opt.userPromotion = {
            bd: NP.times(opt.bd, 1000),
            bdZs: NP.times(opt.bdZs, 1000),
            bdHp: NP.times(opt.bdHp, 1000)
          }
          delete opt.bd
          delete opt.bdHp
          delete opt.bdZs

          if (opt.bdChannelDeduction) {
            opt.userPromotion.bdChannelDeduction = NP.times(opt.bdChannelDeduction, 1000)
          }
          if (opt.bdZsChannelDeduction) {
            opt.userPromotion.bdZsChannelDeduction = NP.times(opt.bdZsChannelDeduction, 1000)
          }
          delete opt.bdChannelDeduction
          delete opt.bdZsChannelDeduction

          // 一级渠道不可以设置二级渠道的佣金比例
          if (this.editType === 1) {
            delete opt.userPromotion
            delete opt.zsPwd
          } 
          
          if (this.editRow && this.editRow.id) {
            this.editHandler({
              ...opt,
              accountId: this.editRow.accountId
            })
          } else {
            this.addHandler(opt)
          }
        } else {
          return false;
        }
      })
    },
    initForm () {
      if (this.editRow && this.editRow.id) {
        this.model.mobile = this.editRow.mobilePhone
        this.model.nickName = this.editRow.nickName
        if (this.editRow.account && this.editRow.account.zsPassword) {
          this.model.zsPwd = this.editRow.account.zsPassword
        }
        if (this.editRow.userPromotion && this.editRow.userPromotion.bd) {
          this.model.bd = (this.editRow.userPromotion.bd / 1000).toFixed(2)
        }
        if (this.editRow.userPromotion && typeof this.editRow.userPromotion.bdHp === 'number') {
          this.model.bdHp = (this.editRow.userPromotion.bdHp / 1000).toFixed(2)
        }
        if (this.editRow.userPromotion && this.editRow.userPromotion.bdZs) {
          this.model.bdZs = (this.editRow.userPromotion.bdZs / 1000).toFixed(2)
        }
        if (this.editRow.userPromotion && typeof this.editRow.userPromotion.bdChannelDeduction === 'number') {
          this.model.bdChannelDeduction = (this.editRow.userPromotion.bdChannelDeduction / 1000)
        }
        if (this.editRow.userPromotion && typeof this.editRow.userPromotion.bdZsChannelDeduction === 'number') {
          this.model.bdZsChannelDeduction = (this.editRow.userPromotion.bdZsChannelDeduction / 1000)
        }
        // 标签
        if (this.editRow.qdTagCodes && this.editRow.qdTagCodes.length) {
          this.model.qdTagLabels = [...this.editRow.qdTagCodes]
        }
      }
    },
    // 新增
    addHandler (opt) {
      saveAccount.call(this, opt).then(res => {
        this.$message.success('新增成功')
        this.$emit('on-success')
      })
    },
    // 修改
    editHandler (opt) {
      editAccount.call(this, opt).then(res => {
        this.$message.success('修改成功')
        this.$emit('on-success')
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-form-item__error {
  padding-top: 3px;
}
.form-title {
  font-size: 16px;
  margin-bottom: 12px;
  border-left: 2px solid #9dc2cf;
  padding-left: 8px;
  font-weight: normal;
}
</style>
